import React, { useEffect, useState } from "react";
import { ParticipantFile } from "../../../../../types/components";
import { useTranslation } from "react-i18next";
import { SectionHeading } from "../../../../atom/SectionHeading";
import { AllDocumentsApproved } from "./AllDocumentsApproved";
import { UploadedDocuments } from "./UploadedDocuments";
import { MissingDocuments } from "./MissingDocuments";
import { NoDocumentsUploaded } from "./NoDocumentsUploaded";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../utils/consts/routes";
import { isStatusApproved, isStatusNotUploaded } from "../../../../../utils/status";

interface DocumentsSectionProps {
  documents?: ParticipantFile[] | null;
}

export const DocumentsSection: React.FC<DocumentsSectionProps> = ({ documents }) => {
  const [missingDocuments, setMissingDocuments] = useState<ParticipantFile[]>([]);
  const [allDocumentsApproved, setAllDocumentsApproved] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const notUploadedDocuments = documents?.filter(({ status }) => !isStatusApproved(status.code));

    setMissingDocuments(documents?.filter(({ status }) => isStatusNotUploaded(status.code)) ?? []);

    if (!notUploadedDocuments || notUploadedDocuments.length > 0) {
      return;
    }

    setAllDocumentsApproved(true);
  }, [documents]);

  const documents_section = !documents
    ? []
    : documents
        ?.filter(({ status }) => !isStatusNotUploaded(status.code))
        .map((file) => ({
          title: file?.type?.name,
          description: file?.type?.description,
          fileType: file?.type?.allowed_file_types,
          status: file?.status?.code,
        }));

  return (
    <div className="flex flex-col gap-[48px]">
      <SectionHeading
        title={t("Documents")}
        subtitle={t(
          "To complete your enrolment, please ensure that all required documents are uploaded.",
        )}
        buttonText={t("View all documents")}
        subtitleClassName="max-w-[520px]"
        onClick={() => navigate(ROUTES.documents)}
      />

      {documents_section.length > 0 ? (
        <>
          {allDocumentsApproved ? (
            <AllDocumentsApproved />
          ) : (
            <>
              <UploadedDocuments documents_section={documents_section} />
              {missingDocuments?.length > 0 && (
                <MissingDocuments missingDocuments={missingDocuments} />
              )}
            </>
          )}
        </>
      ) : (
        <NoDocumentsUploaded />
      )}
    </div>
  );
};
